import script from "./Events.vue?vue&type=script&setup=true&lang=js"
export * from "./Events.vue?vue&type=script&setup=true&lang=js"

import "./Events.vue?vue&type=style&index=0&id=53ef844e&scoped=true&lang=css"

import exportComponent from "/Users/Joe/Documents/Projects/MCR-WebFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53ef844e"]])

export default __exports__